export default {"src":"/_next/static/media/uncheck-outline.d9f60636.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};